import { useContext } from 'react'
import { GoBackToContext } from '../context/GoBackToContext'

export function useGoBackTo(): string {
  return useContext(GoBackToContext)
}
